export const UPDATE_BOARD_REQUEST = "UPDATE_BOARD_REQUEST";
export const UPDATE_BOARD_SUCCESS = "UPDATE_BOARD_SUCCESS";
export const UPDATE_BOARD_FAILURE = "UPDATE_BOARD_FAILURE";
export const INVITE_REQUEST = "INVITE_REQUEST";
export const SEND_INVITE_SUCCESS = "SEND_INVITE_SUCCESS";
